import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Switch } from "./ui/switch";

const KEY = "ngp_cookie_consent";
const CATS = [
  { id: "necessary", label: "Necessari", text: "Indispensabili al funzionamento del sito.", locked: true },
  { id: "analytics", label: "Statistici", text: "Ci aiutano a capire come viene usato il sito." },
  { id: "marketing", label: "Marketing", text: "Contenuti e annunci personalizzati." },
];

export const CookieBanner = () => {
  const [show, setShow] = useState(false);
  const [custom, setCustom] = useState(false);
  const [prefs, setPrefs] = useState({ necessary: true, analytics: false, marketing: false });

  useEffect(() => {
    const t = setTimeout(() => { if (!localStorage.getItem(KEY)) setShow(true); }, 1400);
    return () => clearTimeout(t);
  }, []);

  const save = (p) => { localStorage.setItem(KEY, JSON.stringify({ ...p, necessary: true, date: new Date().toISOString() })); setShow(false); };

  return (
    <AnimatePresence>
      {show && (
        <motion.div role="dialog" aria-live="polite" aria-label="Preferenze cookie" data-testid="cookie-banner"
          initial={{ y: 40, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 40, opacity: 0 }} transition={{ duration: 0.5, ease: [0.2, 0.7, 0.2, 1] }}
          className="fixed bottom-4 left-4 right-20 z-[56] max-w-md rounded-[var(--ngp-radius)] border border-[color:var(--ngp-line)] bg-white p-5 text-[color:var(--ngp-ink)] shadow-[0_30px_80px_-30px_rgba(0,0,0,.45)] sm:bottom-6 sm:left-6 sm:right-auto">
          <p className="font-display text-lg font-semibold">Cookie</p>
          <p className="mt-1 text-sm leading-relaxed text-[color:var(--ngp-muted)]">
            Usiamo cookie tecnici e, con il tuo consenso, statistici e di marketing. <Link to="/privacy-cookie" className="underline underline-offset-2">Maggiori informazioni</Link>
          </p>
          {custom && (
            <ul className="mt-4 divide-y divide-[color:var(--ngp-line)] border-y border-[color:var(--ngp-line)]">
              {CATS.map((c) => (
                <li key={c.id} className="flex items-center justify-between gap-4 py-3">
                  <span><span className="block text-sm font-semibold">{c.label}</span><span className="block text-xs text-[color:var(--ngp-muted)]">{c.text}</span></span>
                  <Switch checked={prefs[c.id]} disabled={c.locked} onCheckedChange={(v) => setPrefs((p) => ({ ...p, [c.id]: v }))} aria-label={c.label} data-testid={`cookie-switch-${c.id}`} />
                </li>
              ))}
            </ul>
          )}
          <div className="mt-4 flex flex-wrap gap-2">
            <button onClick={() => save({ analytics: true, marketing: true })} data-testid="cookie-accept-btn" className="rounded-full bg-[color:var(--ngp-ink)] px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-[color:var(--ngp-teal)] hover:text-[color:var(--ngp-ink)]">Accetta</button>
            <button onClick={() => save({ analytics: false, marketing: false })} data-testid="cookie-reject-btn" className="rounded-full border border-black/25 px-5 py-2.5 text-sm font-semibold hover:border-[color:var(--ngp-ink)]">Rifiuta</button>
            {custom
              ? <button onClick={() => save(prefs)} data-testid="cookie-save-btn" className="px-3 py-2.5 text-sm font-semibold underline underline-offset-2">Salva preferenze</button>
              : <button onClick={() => setCustom(true)} data-testid="cookie-customize-btn" className="px-3 py-2.5 text-sm font-semibold underline underline-offset-2">Personalizza</button>}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
